module.exports = __webpack_public_path__ + "static/media/singsnap-logo@2x.848617aa.png";